
// package imports
import ProductConstants from 'constants/ProductConstants';
import utils from './utils';
import moment from 'moment';

const initialDefaults = (formRef, data) => {
    let requestData = data.data.bi_request
    let planOption = Number(requestData.PlanOption)
    let ppt = requestData.PR_PPT
    let secondaryLaName = requestData.SecondLifeAssuredName
    let secondaryLastName = requestData.SecondLifeAssuredLastName
    let secondaryLaGendar = requestData.SecondLifeAssuredGender
    let secondaryLaDOB = requestData.SecLaDOB
    let pt = requestData.PR_PT
    let pt_value = requestData.PR_PT
    let inputMode = requestData.INPUT_MODE
    let accrualOfSurvivalBenefits = requestData.AccumulationofSurvivalBenefit
    let accrualOfSurvivalBenefit_2 = requestData.AccrualOfSurvivalBenefit_2
    let accrualOfSurvivalBenefit_3 = requestData.AccrualOfSurvivalBenefit_3
    let asbStartYearOne = requestData.ASB_StartPolicyYear_1
    let asbEndYearOne = requestData.ASB_EndPolicyYear_1
    let asbStartYearTwo = requestData.ASB_StartPolicyYear_2
    let asbEndYearTwo = requestData.ASB_EndPolicyYear_2
    let asbStartYearThree = requestData.ASB_StartPolicyYear_3
    let asbEndYearThree = requestData.ASB_EndPolicyYear_3
    let WithdrawalPercentageOne = requestData.WithdrawalPercentage_1
    let WithdrawalPercentageTwo = requestData.WithdrawalPercentage_2
    let WithdrawalPercentageThree = requestData.WithdrawalPercentage_3
    let liAge = Number(requestData.LI_ENTRY_AGE)
    let IncomeFrequencyMode = requestData?.IncomeFrequencyMode
    let TwogetherOption = requestData?.TwogetherOption
    let MaturityBenefitPaymentmode = requestData?.MaturityBenefitPaymentmode
    let MaturityBenefitLumpsum = requestData?.MaturityBenefitLumpsum
    let NumberofMonthswhichMaturityBenefitispaid = requestData?.NumberofMonthswhichMaturityBenefitispaid
    let DeathBenefitPaymentmode = requestData?.DeathBenefitPaymentmode
    let DeathBenefitLumpsum = requestData?.DeathBenefitLumpsum
    let NumberofMonthswhichDeathBenefitispaid = requestData?.NumberofMonthswhichDeathBenefitispaid
    let SurvivalBenefitinadvance = requestData?.SurvivalBenefitinadvance
    let TotalSurvivalBenefit = requestData?.TotalSurvivalBenefit
    let DeathBenefitOption = requestData?.DeathBenefitOption

    let proposition = requestData?.Proposition
    let autoRenewalBooster = requestData?.AutoRenewalBooster
    let accrualPeriod = requestData?.AccrualPeriod
    let rOP = requestData?.ROP
    let isExistingCustomer = requestData?.IsExistingCustomer
    let secLAAge = ""

    if (secondaryLaDOB && Number(TwogetherOption) === 22) {
        secLAAge = moment().diff(moment(secondaryLaDOB, "DD MMM YYYY"), 'years')
    }

    // if (Number(liAge) < 21) {
    //     formRef.$("plan-option").set("disabled", true);
    // } else {
    //     formRef.$("plan-option").set("disabled", false);
    // }

    //! TotalSurvivalBenefit
    if (TotalSurvivalBenefit) {
        formRef.$("total-survival-benefit").set("value", Number(TotalSurvivalBenefit));
    }

    // !Plan Option
    switch (planOption) {
        case 16:
            formRef.$('plan-option').set('value', { label: 'Flexi Value Option', id: 16 })
            formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: false })
            formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: false })
            formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: false })
            formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: false })
            formRef.$('death-benefit-option').set('disabled', false)

            break;
        case 17:

            formRef.$('plan-option').set('value', { label: 'Two-gether Option', id: 17 },)

            let Gender = secondaryLaGendar === "21" ? { label: 'Male', id: "21" } : { label: 'Female', id: "22" }
            formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: true })
            formRef.$('second-life-assured-dob').value = secondaryLaDOB;
            formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: true })
            formRef.$('second-life-assured-gender').value = Gender;
            formRef.$('death-benefit-option').set('disabled', true)
            // formRef.$('death-benefit-option').set('extra', { ...formRef.$('death-benefit-option').extra, optionList: [{ label: 'Option 1', id: 24 },] })

            if (secondaryLaName) {
                let secondaryLAFullName = secondaryLaName.split(" ")
                formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: true })
                formRef.$('second-life-assured-first-name').value = secondaryLAFullName[0];
                formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: true })
                formRef.$('second-life-assured-last-name').value = secondaryLAFullName[1];

            }
            break;
        default:
            break;
    }

    // !Two gether Option

    // switch (Number(TwogetherOption)) {
    //     case 23:
    //         formRef.$('two-gether-option').set('value', { label: 'No', id: 23 })
    //         formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: false })
    //         formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: false })
    //         formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: false })
    //         formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: false })
    //         // formRef.$('death-benefit-option').set('extra', {
    //         //     ...formRef.$('death-benefit-option').extra,
    //         //     optionList: [
    //         //         { label: 'Option 1', id: 24 },
    //         //         { label: 'Option 2', id: 25 }
    //         //     ]
    //         // })
    //         break;
    //     case 22:

    //         formRef.$('two-gether-option').set('value', { label: 'Yes', id: 22 },)
    //         let Gender = secondaryLaGendar === "27" ? { label: 'Male', id: "27" } : { label: 'Female', id: "28" }
    //         formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: true })
    //         formRef.$('second-life-assured-dob').value = secondaryLaDOB;
    //         formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: true })
    //         formRef.$('second-life-assured-gender').value = Gender;
    //         // formRef.$('death-benefit-option').set('extra', { ...formRef.$('death-benefit-option').extra, optionList: [{ label: 'Option 1', id: 24 },] })

    //         if (secondaryLaName) {
    //             let secondaryLAFullName = secondaryLaName.split(" ")
    //             formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: true })
    //             formRef.$('second-life-assured-first-name').value = secondaryLAFullName[0];
    //             formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: true })
    //             formRef.$('second-life-assured-last-name').value = secondaryLAFullName[1];

    //         }
    //         break;
    //     default:
    //         break;
    // }

    switch (Number(DeathBenefitOption)) {
        case 18:
            formRef.$('death-benefit-option').set('value', { label: 'Option 1', id: DeathBenefitOption })
            break;
        case 19:
            formRef.$('death-benefit-option').set('value', { label: 'Option 2', id: DeathBenefitOption })
            break;
        default:
            break;
    }

    switch (Number(autoRenewalBooster)) {
        case 1:
            formRef.$('auto-renewal-booster').set('value', { label: 'Yes', id: autoRenewalBooster })
            break;
        case 0:
            formRef.$('auto-renewal-booster').set('value', { label: 'No', id: autoRenewalBooster })
            break;
        default:
            break;
    }

    switch (Number(isExistingCustomer)) {
        case 1:
            formRef.$('is-existing-customer').set('value', { label: 'Yes', id: isExistingCustomer })
            break;
        case 2:
            formRef.$('is-existing-customer').set('value', { label: 'No', id: isExistingCustomer })
            break;
        default:
            break;
    }

    // !PPT
    let pptList = utils.pptListBasedOnPlanOption(pt)
    formRef.$('premium-term').set('extra', { ...formRef.$('premium-term').extra, optionList: pptList })
    formRef.$('premium-term').set('value', { label: ppt, id: ppt })



    // !PT

    formRef.$('policy-term').set('value', { label: pt, id: pt })
    if (pt) {
        let ptList = formRef.$("policy-term").extra.optionList
        let ptVlaue = ptList?.filter((item) => String(pt) === String(item?.id))
        if (ptVlaue?.length > 0) formRef.$("policy-term").set("value", ptVlaue[0])
    }


    // !Payment frequency
    switch (Number(inputMode)) {
        case 1:
            formRef.$('payment-frequency').set('value', {
                id: '1',
                label: 'Annual'
            })
            break;
        case 2:
            formRef.$('payment-frequency').set('value', {
                id: '2',
                label: 'Semi-Annual'
            })
            break;
        case 3:
            formRef.$('payment-frequency').set('value', {
                id: '3',
                label: 'Quarterly'
            })
            break;
        case 4:
            formRef.$('payment-frequency').set('value', {
                id: '4',
                label: 'Monthly'
            })
            break;

        default:
            break;
    }


    // !Income Frequency Mode
    switch (Number(IncomeFrequencyMode)) {
        case 25:
            formRef.$('income-frequency-mode').set('value', {
                id: 25,
                label: 'Annual'
            })
            break;
        case 26:
            formRef.$('income-frequency-mode').set('value', {
                id: 26,
                label: 'Semi-Annual'
            })
            break;
        case 27:
            formRef.$('income-frequency-mode').set('value', {
                id: 27,
                label: 'Quarterly'
            })
            break;
        case 28:
            formRef.$('income-frequency-mode').set('value', {
                id: 28,
                label: 'Monthly'
            })
            break;

        default:
            break;
    }
    // !proposition
    switch (Number(proposition)) {
        case 1:
            formRef.$('proposition').set('value', {
                id: 1,
                label: 'Lumpsum'
            })
            formRef.$('accrual-period').set('disabled', true)
            break;
        case 2:
            formRef.$('proposition').set('value', {
                id: 2,
                label: 'Income Plus Lump Sum'
            })

            break;
        case 3:
            formRef.$('proposition').set('value', {
                id: 3,
                label: 'Moneyback'
            })
            formRef.$('accrual-period').set('disabled', true)
            break;
        // case 4:
        //     formRef.$('proposition').set('value', {
        //         id: 4,
        //         label: 'Retirement'
        //     })
        //     break;
        case 4:
            formRef.$('proposition').set('value', {
                id: 4,
                label: 'DIY'
            })
            formRef.$('accrual-period').set('disabled', true)
            break;

        default:
            break;
    }
    let propositionList = utils.propositionList(String(pt), Number(ppt), TwogetherOption, secLAAge)
    if (propositionList?.length > 0) {
        formRef.$("proposition").set("extra", {
            ...formRef.$("proposition").extra,
            optionList: propositionList || [],
        });
    }

    if (accrualPeriod) {
        let accrualPeriodList = formRef.$("accrual-period").extra.optionList
        let accrualPeriodValue = accrualPeriodList.filter((item) => Number(accrualPeriod) === Number(item.id))
        if (accrualPeriodValue?.length > 0) formRef.$("accrual-period").set("value", accrualPeriodValue[0])
    }


    let ropList = utils.ropList(Number(proposition))
    if (ropList?.length > 0) {
        formRef.$("ROP").set("extra", {
            ...formRef.$("ROP").extra,
            optionList: ropList || [],
        });
        let ropValue = ropList.filter((item) => Number(rOP) === Number(item.id))
        if (ropValue?.length > 0) formRef.$("ROP").set("value", ropValue[0])
    }

    if (Number(proposition) === 1 || Number(proposition) === 340) {
        formRef.$('ROP').set('disabled', true)
    } else {
        formRef.$('ROP').set('disabled', false)
    }

    // let planOptionList = utils.planOptionList(Number(proposition))
    // if (planOptionList?.length > 0) {
    //     formRef.$("plan-option").set("extra", {
    //         ...formRef.$("plan-option").extra,
    //         optionList: planOptionList || [],
    //     });
    // }
    switch (Number(SurvivalBenefitinadvance)) {
        case 338:
            formRef.$("survival-benefit-advance").set("value", {
                id: SurvivalBenefitinadvance,
                label: 'Yes',
            });
            break;

        case 339:
            formRef.$("survival-benefit-advance").set("value", {
                id: SurvivalBenefitinadvance,
                label: 'No',
            });
            break;

        default:
            break;
    }

    // ! DeathBenefitPaymentmode
    switch (Number(DeathBenefitPaymentmode)) {
        case 1032:
            formRef.$('death-benefit-payment-mode').set('value', { id: '1032', label: 'Lumpsum' })
            formRef.$('death-benefit-lumpsum-percentage').set('disabled', true)
            break;
        case 1033:
            formRef.$('death-benefit-payment-mode').set('value', { id: '1033', label: 'Monthly Income' })
            formRef.$('death-benefit-lumpsum-percentage').set('disabled', true)
            break;
        case 1034:
            formRef.$('death-benefit-payment-mode').set('value', { id: '1034', label: 'Lumpsum Plus Monthly Income' })
            formRef.$('death-benefit-lumpsum-percentage').set('disabled', false)
            break;

        default:
            break;
    }

    // ! MaturityBenefitPaymentmode
    switch (Number(MaturityBenefitPaymentmode)) {
        case 928:
            formRef.$('maturity-benefit-payment-mode').set('value', { id: '928', label: 'Lumpsum' })
            formRef.$('maturity-benefit-lumpsum-percentage').set('disabled', true)
            break;
        case 929:
            formRef.$('maturity-benefit-payment-mode').set('value', { id: '929', label: 'Monthly Income' })
            formRef.$('maturity-benefit-lumpsum-percentage').set('disabled', true)
            break;
        case 930:
            formRef.$('maturity-benefit-payment-mode').set('value', { id: '930', label: 'Lumpsum Plus Monthly Income' })
            formRef.$('maturity-benefit-lumpsum-percentage').set('disabled', false)
            break;

        default:
            break;
    }


    //! NumberofMonthswhichDeathBenefitispaid
    switch (Number(NumberofMonthswhichDeathBenefitispaid)) {
        case 1134:
            formRef.$('number-of-months-maturity-benefit-paid').set('value', { id: '1134', label: '36' })
            break;
        case 1135:
            formRef.$('number-of-months-maturity-benefit-paid').set('value', { id: '1135', label: '60' })
            break;
        default:
            break;
    }

    //! NumberofMonthswhichMaturityBenefitispaid
    switch (Number(NumberofMonthswhichMaturityBenefitispaid)) {
        case 1030:
            formRef.$('number-of-months-death-benefit-paid').set('value', { id: '1030', label: '36' })
            break;
        case 1031:
            formRef.$('number-of-months-death-benefit-paid').set('value', { id: '1031', label: '60' })
            break;
        default:
            break;
    }

    if (Number(DeathBenefitPaymentmode) === 1034) {
        let deathBenefitPercentageList = formRef.$("death-benefit-lumpsum-percentage").extra.optionList
        let deathBenefitPercentage = deathBenefitPercentageList.filter((item) => Number(DeathBenefitLumpsum) === Number(item.id))
        if (deathBenefitPercentage.length > 0) formRef.$("death-benefit-lumpsum-percentage").set("value", deathBenefitPercentage[0])
    }

    if (Number(MaturityBenefitPaymentmode) === 930) {
        let maturityBenefitPercentageList = formRef.$("maturity-benefit-lumpsum-percentage").extra.optionList
        let maturityBenefitPercentage = maturityBenefitPercentageList.filter((item) => Number(MaturityBenefitLumpsum) === Number(item.id))
        if (maturityBenefitPercentage.length > 0) formRef.$("maturity-benefit-lumpsum-percentage").set("value", maturityBenefitPercentage[0])

    }
    let asbList = [{ label: 'Yes', id: 23 }]
    let survivalBenefitList = []
    // if (Number(proposition) === 3 || Number(proposition) === 340) {
        if (Number(proposition) === 4) {
            asbList.push({ label: 'No', id: 24 })
        }
        // survivalBenefitList.push({ label: 'Yes', id: 338 })
    // }
    formRef.$("accrual-of-survival-benefit").set("extra", {
        ...formRef.$("accrual-of-survival-benefit").extra,
        optionList: asbList || [],
    });
    // survivalBenefitList.push({ label: 'No', id: 339 },)
    // formRef.$("survival-benefit-advance").set("extra", {
    //     ...formRef.$("survival-benefit-advance").extra,
    //     optionList: survivalBenefitList || [],
    // });
    // let incomeFrequencyModeList = [{ label: 'Annual', id: 334 }]
    // if (Number(proposition) === 2 || Number(proposition) === 3 || Number(proposition) === 4 || Number(proposition) === 340) {
    //     incomeFrequencyModeList.push({ label: 'Semi-Annual', id: 335 })
    //     incomeFrequencyModeList.push({ label: 'Quarterly', id: 336 })
    //     incomeFrequencyModeList.push({ label: 'Monthly', id: 337 })
    // }
    // formRef.$("income-frequency-mode").set("extra", {
    //     ...formRef.$("income-frequency-mode").extra,
    //     optionList: incomeFrequencyModeList || [],
    // });

    // !Accrual Of Survival Benefits
    switch (Number(accrualOfSurvivalBenefits)) {
        case 23:
            formRef.$('accrual-of-survival-benefit').set('value', { label: 'Yes', id: "23" })
            break;

        case 24:
            formRef.$('accrual-of-survival-benefit').set('value', { label: 'No', id: "24" })
            break;

        default:
            break;
    }

    // formRef.$("accrual-of-survival-benefits").set("disabled", true);
    utils.handleAsbCondition(formRef, accrualOfSurvivalBenefits)
    // Initial value of ASB Start year 1

    let asbStartYearOneList = utils.fetchASBstartPolicyOne(planOption, pt_value, ppt, formRef.$("asb-start-age-(1st-opt-in)").extra.preDefinedOptList, liAge)
    formRef.$("asb-start-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
    });


    let asbStartYearOneOpt = asbStartYearOneList.filter((item) => Number(asbStartYearOne) === item.id)
    if (asbStartYearOneOpt.length > 0) formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneOpt[0])

    // Initial value of ASB End year 1
    let asbEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(1st-opt-in)").value.id, asbStartYearOneList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
    });
    let asbEndYearOneOpt = asbEndYearOneList.filter((item) => Number(asbEndYearOne) === Number(item.id))
    if (asbEndYearOneOpt.length > 0) formRef.$("asb-end-age-(1st-opt-in)").set("value", asbEndYearOneOpt[0])

    let asbWithDrawalParcentage1 = formRef.$("withdrawal-parcentage-1").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-1").set("extra", {
        ...formRef.$("withdrawal-parcentage-1").extra,
        optionList: asbWithDrawalParcentage1,
    });

    let withdrawalPercentage1 = asbWithDrawalParcentage1.filter((item) => Number(WithdrawalPercentageOne) === Number(item.id))
    if (withdrawalPercentage1.length > 0) formRef.$("withdrawal-parcentage-1").set("value", withdrawalPercentage1[0])

    switch (Number(accrualOfSurvivalBenefit_2)) {
        case 315:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'Yes',
            });
            break;

        case 316:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbTwoCondition(formRef, accrualOfSurvivalBenefit_2)

    // Initial value of ASB Start year 2
    let asbTwoStartYearOneList = utils.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(1st-opt-in)").value.id + 2,
        formRef.$("asb-end-age-(1st-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(2nd-opt-in)").extra.preDefinedOptList
    );
    formRef.$("asb-start-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(2nd-opt-in)").extra,
        optionList: asbTwoStartYearOneList,
    });
    let asbTwoStartYearOneOpt = asbTwoStartYearOneList.filter((item) => Number(asbStartYearTwo) === item.id)
    if (asbTwoStartYearOneOpt.length > 0) formRef.$("asb-start-age-(2nd-opt-in)").set("value", asbTwoStartYearOneOpt[0])

    // Initial value of ASB End year 2
    let asbTwoEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(2nd-opt-in)").value.id, asbTwoStartYearOneList, formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
        optionList: asbTwoEndYearOneList,
    });
    let asbTwoEndYearOneOpt = asbTwoEndYearOneList.filter((item) => Number(asbEndYearTwo) === item.id)
    if (asbTwoEndYearOneOpt.length > 0) formRef.$("asb-end-age-(2nd-opt-in)").set("value", asbTwoEndYearOneOpt[0])

    let asbWithDrawalParcentage2 = formRef.$("withdrawal-parcentage-2").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-2").set("extra", {
        ...formRef.$("withdrawal-parcentage-2").extra,
        optionList: asbWithDrawalParcentage2,
    });

    let withdrawalPercentage2 = asbWithDrawalParcentage2.filter((item) => Number(WithdrawalPercentageTwo) === Number(item.id))
    if (withdrawalPercentage2.length > 0) formRef.$("withdrawal-parcentage-2").set("value", withdrawalPercentage2[0])




    // Initial value of accrual of survival benefits 3
    switch (Number(accrualOfSurvivalBenefit_3)) {
        case 621:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'Yes',
            });
            break;

        case 621:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbThreeCondition(formRef, accrualOfSurvivalBenefit_3)

    // Initial value of ASB Start year 2
    let asbThreeStartYearOneList = utils.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(2nd-opt-in)").value.id + 2,
        formRef.$("asb-end-age-(2nd-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(3rd-opt-in)").extra.preDefinedOptList,
        liAge
    );
    formRef.$("asb-start-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(3rd-opt-in)").extra,
        optionList: asbThreeStartYearOneList,
    });
    let asbThreeStartYearOneOpt = asbThreeStartYearOneList.filter((item) => Number(asbStartYearThree) === item.id)
    if (asbThreeStartYearOneOpt.length > 0) formRef.$("asb-start-age-(3rd-opt-in)").set("value", asbThreeStartYearOneOpt[0])

    // Initial value of ASB End year 2
    let asbThreeEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(3rd-opt-in)").value.id, asbThreeStartYearOneList, formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
    });

    let asbThreeEndYearOneOpt = asbThreeEndYearOneList.filter((item) => Number(asbEndYearThree) === item.id)
    if (asbThreeEndYearOneOpt.length > 0) formRef.$("asb-end-age-(3rd-opt-in)").set("value", asbThreeEndYearOneOpt[0])

    let asbWithDrawalParcentage3 = formRef.$("withdrawal-parcentage-3").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-3").set("extra", {
        ...formRef.$("withdrawal-parcentage-3").extra,
        optionList: asbWithDrawalParcentage3,
    });

    let withdrawalPercentage3 = asbWithDrawalParcentage3.filter((item) => Number(WithdrawalPercentageThree) === Number(item.id))
    if (withdrawalPercentage3.length > 0) formRef.$("withdrawal-parcentage-3").set("value", withdrawalPercentage3[0])


    // if (Number(proposition) === 1) {
    //     utils.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true)
    //     utils.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true)
    //     utils.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true)
    // }
    switch (data.productName) {

        case ProductConstants.FLEXI_GOAL_SECURE:
            formRef.$('accrual-of-survival-benefit').set('disabled', false)
            break;

        default:
            break;
    }
    // !Riders
    if (requestData.ADBRider) {
        formRef.$('ADB').set('value', requestData.ADBRider !== '')
        if (requestData.ADBRider) {
            formRef.$('ADB-dropdown').set('value', requestData.ADBRider)
        }
    }
    if (requestData.ATPDRider) {
        formRef.$('ATPDRider').set('value', requestData.ATPDRider !== '')
        if (requestData.ATPDRider) {
            formRef.$('ATPDRider-dropdown').set('value', requestData.ATPDRider)
        }
    }
    if (requestData.WaiverOfPremiumRider) {
        formRef.$('WaiverOfPremiumRider').set('value', requestData.WaiverOfPremiumRider !== '')
    }

    if (requestData.IncomeBenefitRider) {
        formRef.$('IncomeBenefitRider').set('value', requestData.IncomeBenefitRider !== '')
        if (requestData.IncomeBenefitRider) {
            formRef.$('IncomeBenefitRider-dropdown').set('value', requestData.IncomeBenefitRider)
        }
    }
    if (requestData.CriticalIllnessRider) {
        formRef.$('CriticalIllnessRider').set('value', requestData.CriticalIllnessRider !== '')
        if (requestData.CriticalIllnessRider) {
            formRef.$('CriticalIllnessRider-dropdown').set('value', requestData.CriticalIllnessRider)
        }
    }
    if (requestData.PayorWaiverBenefitRider) {
        formRef.$('PayorWaiverBenefitRider').set('value', requestData.PayorWaiverBenefitRider !== '')
        if (formRef.$('PayorWaiverBenefitRider').value) {
            switch (requestData.PWB) {
                case '1':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '1',
                        label: 'Option 1 (On Death)'
                    })
                    break;
                case '2':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '2',
                        label: 'Option 2 (CI or ATPD)'
                    })
                    break;
                case '3':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '3',
                        label: 'Option 3 (CI or ATPD or Death)'
                    })
                    break;
                default:
                    break;
            }
        }


        formRef.$('ADB').set('extra', { ...formRef.$('ADB').extra, hide: false })
        formRef.$('PayorWaiverBenefitRider').set('extra', { ...formRef.$('PayorWaiverBenefitRider').extra, hide: false })
        formRef.$('ATPDRider').set('extra', { ...formRef.$('ATPDRider').extra, hide: false })
        formRef.$('CriticalIllnessRider').set('extra', { ...formRef.$('CriticalIllnessRider').extra, hide: false })
        formRef.$('IncomeBenefitRider').set('extra', { ...formRef.$('IncomeBenefitRider').extra, hide: false })
        formRef.$('WaiverOfPremiumRider').set('extra', { ...formRef.$('WaiverOfPremiumRider').extra, hide: false })

    }

}

export default initialDefaults